import {Toast} from "vant";

export const showLoading = () => {
    Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
};

export const hiddenLoading = () => {
    Toast.clear(true);
};

export const showToast = (msg) => {
    Toast({message: msg, duration: 2000, icon: 'none'});
};
